import React from 'react';

const SupplyChainSoftwareDevelopment = () => {
    return (
        <div className="pt-100">
            <div className="container lg:container md:mx-auto">
                <div className="row grid lg:grid-cols-12 mb-50">
                    <div className="lg:col-span-4">
                        <div>
                            <h2 className="text-primary" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                                Maximize Control with Custom Supply Chain Software Development Services
                            </h2>
                        </div>
                    </div>
                    <div className="lg:col-span-8">
                        <p className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            Outdated tools and fragmented systems don&apos;t just slow you down, they cost you time, money, and
                            trust. Our supply chain software development solutions are built to fix that. From inventory
                            intelligence to predictive procurement, we engineer systems that help mid-level and large-scale
                            businesses stay ahead of demand, avoid delays, and scale without chaos.
                        </p>
                        <p className="mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            As a leading supply chain software development company, we create future-ready, AI-integrated
                            platforms tailored to your needs—no fluff, no bloat, just results.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SupplyChainSoftwareDevelopment;
